import { render, staticRenderFns } from "./SBKurukuru.html?vue&type=template&id=26b255aa&scoped=true&"
import script from "./SBKurukuru.ts?vue&type=script&lang=ts&"
export * from "./SBKurukuru.ts?vue&type=script&lang=ts&"
import style0 from "./SBKurukuru.css?vue&type=style&index=0&id=26b255aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b255aa",
  null
  
)

export default component.exports